import Box from '@mui/material/Box';
import { Form } from 'components/@shared/Form/Form';
import Stack from '@mui/material/Stack';
import { FormTextField } from 'components/@shared/Form/TextField';
import { GoBackButton } from 'components/@shared/GoBackButton';
import Button from '@mui/material/Button';
import { ProposalFormData } from 'types/proposal';
import { validationSchema } from './validation';
import { ProposalFormItems } from './ProposalFormItems';
import { ProposalFormTotal } from './ProposalFormTotal';

interface Props {
    initialData: ProposalFormData;
    onSubmit: (values: ProposalFormData) => void;
}

export const ProposalForm = ({ initialData, onSubmit }: Props) => {
    return (
        <Form initialValues={initialData} validationSchema={validationSchema} onSubmit={onSubmit}>
            <Stack gap={2} pt={3} pb={3} maxWidth={1000} mx="auto">
                <FormTextField name="title" label="Title" fullWidth size="small" />
                <ProposalFormItems />
                <ProposalFormTotal />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                    <GoBackButton />
                    <Button variant="contained" type="submit">
                        Save
                    </Button>
                </Box>
            </Stack>
        </Form>
    );
};
